// Organization names follow `BAC-XX-00000`; a trailing suffix (" demo", ...) is
// ignored. Group 2 is the 5-digit code. Kept in sync with the backend's
// ORG_NAME_RE in services/default-users.js.
export const ORG_NAME_RE = /^BAC-([A-Z]{2})-(\d{5})\b/;

// The 5-digit organization code, or null when the name doesn't follow the format.
export const parseOrgCode = name => {
    const match = ORG_NAME_RE.exec(name || '');
    return match ? match[2] : null;
};

// Every site is reachable at `<code>.site.belaircinema.com:8446`. This is only
// the value proposed from the name — the stored `siteUrl` stays editable.
export const deriveSiteUrl = name => {
    const code = parseOrgCode(name);
    return code ? `http://${code}.site.belaircinema.com:8446/` : '';
};

// The URL to open for an organization: the saved one, falling back to the value
// derived from the name for organizations that predate the field.
export const organizationSiteUrl = organization =>
    organization?.siteUrl || deriveSiteUrl(organization?.name);
